import { PATH_INBOX } from '@/config/paths';
import { EOrder } from '@/types/EOrder';
import { ICaseTableFiltersExtended } from '@/types/ICaseTableFiltersExtended';
import { ICaseTableOrder } from '@/types/ICaseTableOrder';
import { GridSortModel, GridFilterModel } from '@mui/x-data-grid';
import { makeAutoObservable } from 'mobx';

export class UserPreferenceStore {
  public lastInboxPath: string = PATH_INBOX;
  public showDrafts: boolean = false;
  public newCasesHasAudio: boolean | null = true;
  public newCasesHasText: boolean | null = true;

  public flaggedCasesFilters: ICaseTableFiltersExtended;
  public flaggedCasesOrder: ICaseTableOrder;

  public completedCasesFilters: ICaseTableFiltersExtended;
  public completedCasesOrder: ICaseTableOrder;

  public inboxFiltersModel: GridFilterModel;
  public inboxSortModel: GridSortModel = [{ field: 'status', sort: 'asc' }];

  public historyFiltersModel: GridFilterModel;
  public historySortModel: GridSortModel = [{ field: 'created_at', sort: 'desc' }];

  constructor() {
    makeAutoObservable(this);
    this.flaggedCasesOrder = {
      order: EOrder.ASC,
      orderBy: 'created_at',
    };
  }

  public setInboxFiltersModel = (model: GridFilterModel) => {
    this.inboxFiltersModel = model;
  };

  public setInboxSortModel = (model: GridSortModel) => {
    this.inboxSortModel = model;
  };

  public setHistoryFiltersModel = (model: GridFilterModel) => {
    this.historyFiltersModel = model;
  };

  public setHistorySortModel = (model: GridSortModel) => {
    this.historySortModel = model;
  };

  public setLastInboxPath = (path: string) => {
    this.lastInboxPath = path;
  };

  public setShowDrafts = (showDrafts: boolean) => {
    this.showDrafts = showDrafts;
  };

  public setNewCasesHasAudio = (newCasesHasAudio: boolean | null) => {
    this.newCasesHasAudio = newCasesHasAudio;
  };

  public setNewCasesHasText = (newCasesHasText: boolean | null) => {
    this.newCasesHasText = newCasesHasText;
  };

  public setFlaggedCasesFilters = (filters: ICaseTableFiltersExtended) => {
    this.flaggedCasesFilters = this.mergeFilters(this.flaggedCasesFilters, filters);
  };

  public setFlaggedCasesOrder = (orderBy: string, order: EOrder) => {
    this.flaggedCasesOrder = {
      order,
      orderBy,
    };
  };

  public setCompletedCasesFilters = (filters: ICaseTableFiltersExtended) => {
    this.completedCasesFilters = this.mergeFilters(this.completedCasesFilters, filters);
  };

  public setCompletedCasesOrder = (orderBy: string, order: EOrder) => {
    this.completedCasesOrder = {
      order,
      orderBy,
    };
  };

  private mergeFilters = (
    oldFilters: ICaseTableFiltersExtended,
    newFilters: ICaseTableFiltersExtended,
  ) => {
    const mergedFilters = { ...oldFilters };

    Object.keys(newFilters).forEach((key: string) => {
      mergedFilters[key] = newFilters[key];
    });

    return mergedFilters;
  };
}
